import { render, staticRenderFns } from "./profesiogramaForm.vue?vue&type=template&id=54a1450b"
import script from "./profesiogramaForm.vue?vue&type=script&lang=js"
export * from "./profesiogramaForm.vue?vue&type=script&lang=js"
import style0 from "./profesiogramaForm.vue?vue&type=style&index=0&id=54a1450b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports